import styled from '@emotion/styled';

export const StyledLink = styled.a({
    color: 'currentcolor',
    ':is(:hover, :focus)': {
        textDecoration: 'underline',
    },
});
